import { render, staticRenderFns } from "./CertifikatJavnoPDFIP.vue?vue&type=template&id=cd83a040&scoped=true&"
import script from "./CertifikatJavnoPDFIP.vue?vue&type=script&lang=js&"
export * from "./CertifikatJavnoPDFIP.vue?vue&type=script&lang=js&"
import style0 from "./CertifikatJavnoPDFIP.vue?vue&type=style&index=0&id=cd83a040&scoped=true&lang=css&"
import style1 from "./CertifikatJavnoPDFIP.vue?vue&type=style&index=1&id=cd83a040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd83a040",
  null
  
)

export default component.exports